export default "__VITE_ASSET__BhoW0mxT__"